import { render, staticRenderFns } from "./AppNavItem.vue?vue&type=template&id=3a8beff8&scoped=true&"
import script from "./AppNavItem.vue?vue&type=script&lang=ts&"
export * from "./AppNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavItem.vue?vue&type=style&index=0&id=3a8beff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8beff8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VTooltip})
